import { ANT_GETLISTADO_COMPLETE } from "../../const/actionTypes";
import { get } from "lodash";

const initialState = {
  listado: { feriados: [], guardados: [], solicitudes: [] },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ANT_GETLISTADO_COMPLETE:
      return { ...state, listado: get(action, "payload") };
    default:
      return { ...state };
  }
}
